import React from 'react';
import { FadeIn } from '../ui/FadeIn';
export function Transformation() {
  return <section className="w-full max-w-5xl mx-auto px-4 md:px-8" data-id="element-378">
      <FadeIn className="text-center mb-12" data-id="element-379">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-380">
          The Transformation
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream" data-id="element-381">
          This Is The Difference A System Makes.
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-382">
        <FadeIn direction="left" className="h-full" data-id="element-383">
          <div className="bg-[#2a1212] border border-red-900/30 rounded-2xl p-6 md:p-8 h-full" data-id="element-384">
            <h3 className="font-playfair text-xl text-red-400/80 mb-6" data-id="element-385">
              Before Resin Without Errors™
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-386">
              <li className="flex items-start gap-3" data-id="element-387">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-388">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-389">
                  Sticky, tacky resin you have to throw away
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-390">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-391">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-392">
                  Bubbles ruining every pour
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-393">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-394">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-395">
                  Hours on YouTube, still confused
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-396">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-397">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-398">
                  Wasted money on supplies that don't work
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-399">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-400">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-401">
                  Feeling like everyone else can do it but you
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-402">
                <span className="text-red-400/70 font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-403">
                  ✗
                </span>
                <span className="font-lato text-cream/70" data-id="element-404">
                  Nothing you'd be proud to sell
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>

        <FadeIn direction="right" className="h-full" data-id="element-405">
          <div className="bg-[#122a14] border border-amber/20 rounded-2xl p-6 md:p-8 h-full" data-id="element-406">
            <h3 className="font-playfair text-xl text-amber mb-6" data-id="element-407">
              After Resin Without Errors™
            </h3>
            <ul className="flex flex-col gap-4" data-id="element-408">
              <li className="flex items-start gap-3" data-id="element-409">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-410">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-411">
                  Clean, professional pieces every pour
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-412">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-413">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-414">
                  Zero bubbles with the Anti-Bubble Protocol™
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-415">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-416">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-417">
                  A clear system that tells you exactly what to do
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-418">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-419">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-420">
                  Stop wasting supplies — buy only what you need
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-421">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-422">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-423">
                  Confidence at your workbench for the first time
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-424">
                <span className="text-amber font-bold text-lg flex-shrink-0" aria-hidden="true" data-id="element-425">
                  ✓
                </span>
                <span className="font-lato text-cream/90" data-id="element-426">
                  Your first sell-ready piece by Day 6
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}